import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { CaptacionPanel } from "@/components/admin/captacion/CaptacionPanel";

export const Route = createFileRoute("/admin/captacion")({
  validateSearch: zodValidator(
    z.object({
      open: z.string().uuid().optional(),
      vista: z.enum(["disponibles", "mias", "equipo", "historial", "direccion"]).optional(),
      fuente: z.enum(["particulares", "agencias", "todos"]).optional(),
      q: z.string().max(120).optional(),
      page: z.number().int().min(1).optional(),
      pageSize: z.number().int().min(1).max(200).optional(),
    }),
  ),
  component: CaptacionPanel,
});
